module.exports = __webpack_public_path__ + "img/achievements-mockup.9660981c.png";